import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarAseguradoUrl = (request) =>
  `api/v1/websalud/primeraars/asegurado/${request.numeroPlastico}`;
const consultarNumeroPlasticoUrl =
  "api/v1/websalud/primeraars/asegurado/plastico";

const consultarAsegurado = (request) =>
  InterceptToken(
    BaseApi.get,
    consultarAseguradoUrl(request.requestData),
    null,
    request.requestHeaders
  ).then((response) => response.data);

const consultarNumeroPlastico = (request) =>
  InterceptToken(BaseApi.get, consultarNumeroPlasticoUrl, request).then(
    (response) => response.data
  );

const exportedObject = {
  consultarAsegurado,
  consultarNumeroPlastico,
};

export default exportedObject;
